import * as React from 'react';
import { Table, Button } from 'antd';
import { imageUrl, noImageUrl } from '../../../../config/config';
import PriceDisplay from '../../../../components/Others/PriceDisplay';

interface IOrderedItemsProps {
  order: GQL.IOrder;
  attributes: any;

  onEditItem: (item: GQL.IOrderItem) => void;
  onDeleteItem: (id: string) => void;
}

class OrderedItems extends React.Component<IOrderedItemsProps> {

  constructor(props: IOrderedItemsProps) {
    super(props);

    this.getAttributes = this.getAttributes.bind(this);
  }

  public render() {
    const { order } = this.props;

    const language = this.props.order.language;

    return (
      <Table
        rowKey={(record: GQL.IOrderItem) => record.id}
        dataSource={order.orderedItems}
      >
        <Table.Column
          render={(u, row: GQL.IOrderItem) => {
            if (!row.product) {
              return null;
            }
            return (
              <div
                style={{
                  width: '100%',
                  overflow: 'hidden',
                  textAlign: 'left',
                  verticalAlign: 'middle'
                }}
              >
                <img
                  style={{
                    width: '80px',
                    height: '80px',
                    margin: '5px'
                  }}
                  alt={row.title}
                  src={(row.image && `${imageUrl}/static/${row.image.file}`) || noImageUrl}
                />
              </div>
            );
          }}
          title="Image"
          dataIndex="image"
          key="image"
          width={90}
        />
        <Table.Column
          title="Product"
          dataIndex="ean"
          key="ean"
          render={(u, row: GQL.IOrderItem) => {
            return (
              <React.Fragment>
                <strong>{row.name[language] ? row.name[language] : row.title}</strong><br />
                {row.sku &&
                  <small>
                    {this.getAttributes(row)}<br />
                    Code: {row.sku}
                  </small>}
                {row.additionalDescription && <>
                  <br />
                  <small>{row.additionalDescription.map((d) => <>{d}<br /></>)}</small>
                  </> || ''}
              </React.Fragment>);
          }}
        />
        <Table.Column
          title="Vat"
          dataIndex="VATrate"
          key="VATrate"
          align="center"
          width={90}
          render={(u, row: GQL.IOrderItem) => {
            return <span>{row.VATrate} %</span>;
          }}
        />
        <Table.Column
          title={<span>Unit price<br />incl. VAT</span>}
          dataIndex="price"
          key="price"
          align="right"
          width={140}
          render={(u, row: GQL.IOrderItem) => {
            return (
              <React.Fragment>
                {!!row.recommendedPrice && row.recommendedPrice > 0 && row.recommendedPrice > row.price &&
                  <React.Fragment>
                    <PriceDisplay amount={row.recommendedPrice} currency={order.currency} className="recommendedPrice" />
                    <br />
                  </React.Fragment>}
                <PriceDisplay amount={row.price} currency={order.currency} />
              </React.Fragment>
            );
          }}
        />
        <Table.Column
          title="Qty"
          dataIndex="quantity"
          key="quantity"
          align="right"
          width={90}
        />
        <Table.Column
          title={<span>Total price<br />incl. VAT</span>}
          dataIndex="total"
          key="total"
          align="right"
          width={140}
          render={(u, row: GQL.IOrderItem) => {
            return <PriceDisplay amount={Math.round(row.price * row.quantity * 100) / 100} currency={order.currency} />;
          }}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          key="actions"
          width={170}
          align="center"
          render={(u: any, row: GQL.IOrderItem) => this.renderActions(row)}
        />
      </Table>
    );
  }

  private renderActions(orderItem: GQL.IOrderItem) {
    return (
      <React.Fragment>
        <Button
          onClick={() => this.props.onEditItem(orderItem)}
          type={'dashed'}
        >
          Edit
        </Button>
        <Button danger={true} onClick={() => this.props.onDeleteItem(orderItem.id)}>
          Delete
        </Button>
      </React.Fragment>
    );
  }

  private getAttributes(orderItem: GQL.IOrderItem) {
    if (!this.props.attributes || !this.props.attributes.attributes) {
      return '...loading attributes';
    }

    const attributes = this.props.attributes.attributes;

    if (orderItem.definition) {
      return Object.keys(orderItem.definition)
        .reduce((acc, attrId) => {
          if (attrId === 'visual') {
            return acc;
          }

          const attribute = attributes.find((attr: any) => attr.id === attrId);

          if (attribute) {
            const attributeTitle = `${attribute && attribute.title}: ${this.getAttributeValue(attribute.values, orderItem.definition[attrId])}`;
            return `${acc}${acc && ','} ${attributeTitle}`;
          }

          return '';
        }, '');
    }

    return '';
  }

  private getAttributeValue(values: Array<any>, attrValueId: string) {
    if (values) {
      // SV: attrValueId may be also an array (even if type is set as string only), so it is necessary to handle it correctly
      if ( Array.isArray(attrValueId)) {
        const strings:string[] = [];
        attrValueId.forEach((avid) => {
          const value = values.find((attrValue: any) => attrValue.id === avid);
          if (value) {
            strings.push(value.title);
          }
        });
        if (strings.length < 1) {
          return '&loz;';
        }
        return strings.join(', ');
      }
      const value = values.find((attrValue: any) => attrValue.id === attrValueId);
      return (value && value.title) || '&ndash;';
    }

    return '&ndash;';
  }
}

export default OrderedItems;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/OrderedItems/OrderedItems.tsx